// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type GetDashboardCollaboratorsQueryVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type GetDashboardCollaboratorsQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { dashboard?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DashboardModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.DashboardModelAsAdminQueries, 'id'>
      & { collaborators?: PrivateSchemaTypes.Maybe<Array<(
        { __typename?: 'DashboardAccessModel' }
        & Pick<PrivateSchemaTypes.DashboardAccessModel, 'id' | 'role'>
        & { user?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'UserModel' }
          & Pick<PrivateSchemaTypes.UserModel, 'id' | 'display_name' | 'isCurrentUser' | 'userIdentity' | 'image_url'>
        )> }
      )>> }
    )> }
  )> }
);

export type DeleteCollaboratorMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  collaboratorId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type DeleteCollaboratorMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { dashboard?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DashboardModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.DashboardModelAsAdminMutations, 'id'>
      & { collaborator?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'DashboardAccessModel' }
        & Pick<PrivateSchemaTypes.DashboardAccessModel, 'id'>
        & { remove?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DashboardAccessModel' }
          & Pick<PrivateSchemaTypes.DashboardAccessModel, 'id'>
        )> }
      )> }
    )> }
  )> }
);

export type ChangeCollaboratorRoleMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  collaboratorId: PrivateSchemaTypes.Scalars['PositiveInt'];
  role: PrivateSchemaTypes.DashboardAccessRoleEnum;
}>;


export type ChangeCollaboratorRoleMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { dashboard?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'DashboardModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.DashboardModelAsAdminMutations, 'id'>
      & { collaborator?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'DashboardAccessModel' }
        & Pick<PrivateSchemaTypes.DashboardAccessModel, 'id'>
        & { changeRole?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DashboardAccessModel' }
          & Pick<PrivateSchemaTypes.DashboardAccessModel, 'id'>
        )> }
      )> }
    )> }
  )> }
);


export const GetDashboardCollaboratorsDocument = gql`
    query getDashboardCollaborators($id: PositiveInt!) {
  admin {
    dashboard(id: $id) {
      id
      collaborators {
        id
        role
        user {
          id
          display_name
          isCurrentUser
          userIdentity
          image_url
        }
      }
    }
  }
}
    `;

/**
 * __useGetDashboardCollaboratorsQuery__
 *
 * To run a query within a React component, call `useGetDashboardCollaboratorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardCollaboratorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardCollaboratorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDashboardCollaboratorsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDashboardCollaboratorsQuery, GetDashboardCollaboratorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDashboardCollaboratorsQuery, GetDashboardCollaboratorsQueryVariables>(GetDashboardCollaboratorsDocument, options);
      }
export function useGetDashboardCollaboratorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDashboardCollaboratorsQuery, GetDashboardCollaboratorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDashboardCollaboratorsQuery, GetDashboardCollaboratorsQueryVariables>(GetDashboardCollaboratorsDocument, options);
        }
export type GetDashboardCollaboratorsQueryHookResult = ReturnType<typeof useGetDashboardCollaboratorsQuery>;
export type GetDashboardCollaboratorsLazyQueryHookResult = ReturnType<typeof useGetDashboardCollaboratorsLazyQuery>;
export type GetDashboardCollaboratorsQueryResult = Apollo.QueryResult<GetDashboardCollaboratorsQuery, GetDashboardCollaboratorsQueryVariables>;
export const DeleteCollaboratorDocument = gql`
    mutation deleteCollaborator($id: PositiveInt!, $collaboratorId: PositiveInt!) {
  admin {
    dashboard(id: $id) {
      id
      collaborator(collaboratorId: $collaboratorId) {
        id
        remove {
          id
        }
      }
    }
  }
}
    `;
export type DeleteCollaboratorMutationFn = Apollo.MutationFunction<DeleteCollaboratorMutation, DeleteCollaboratorMutationVariables>;

/**
 * __useDeleteCollaboratorMutation__
 *
 * To run a mutation, you first call `useDeleteCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollaboratorMutation, { data, loading, error }] = useDeleteCollaboratorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      collaboratorId: // value for 'collaboratorId'
 *   },
 * });
 */
export function useDeleteCollaboratorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCollaboratorMutation, DeleteCollaboratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCollaboratorMutation, DeleteCollaboratorMutationVariables>(DeleteCollaboratorDocument, options);
      }
export type DeleteCollaboratorMutationHookResult = ReturnType<typeof useDeleteCollaboratorMutation>;
export type DeleteCollaboratorMutationResult = Apollo.MutationResult<DeleteCollaboratorMutation>;
export type DeleteCollaboratorMutationOptions = Apollo.BaseMutationOptions<DeleteCollaboratorMutation, DeleteCollaboratorMutationVariables>;
export const ChangeCollaboratorRoleDocument = gql`
    mutation changeCollaboratorRole($id: PositiveInt!, $collaboratorId: PositiveInt!, $role: DashboardAccessRoleEnum!) {
  admin {
    dashboard(id: $id) {
      id
      collaborator(collaboratorId: $collaboratorId) {
        id
        changeRole(role: $role) {
          id
        }
      }
    }
  }
}
    `;
export type ChangeCollaboratorRoleMutationFn = Apollo.MutationFunction<ChangeCollaboratorRoleMutation, ChangeCollaboratorRoleMutationVariables>;

/**
 * __useChangeCollaboratorRoleMutation__
 *
 * To run a mutation, you first call `useChangeCollaboratorRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCollaboratorRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCollaboratorRoleMutation, { data, loading, error }] = useChangeCollaboratorRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      collaboratorId: // value for 'collaboratorId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useChangeCollaboratorRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeCollaboratorRoleMutation, ChangeCollaboratorRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChangeCollaboratorRoleMutation, ChangeCollaboratorRoleMutationVariables>(ChangeCollaboratorRoleDocument, options);
      }
export type ChangeCollaboratorRoleMutationHookResult = ReturnType<typeof useChangeCollaboratorRoleMutation>;
export type ChangeCollaboratorRoleMutationResult = Apollo.MutationResult<ChangeCollaboratorRoleMutation>;
export type ChangeCollaboratorRoleMutationOptions = Apollo.BaseMutationOptions<ChangeCollaboratorRoleMutation, ChangeCollaboratorRoleMutationVariables>;